import React from 'react';
import * as SC from '@components/common/buttons/ResetBtn.style';
import Icon from '@components/common/Icon';
import useTheme from '@stores/themeStore';

type Props = { label: string } & React.ButtonHTMLAttributes<HTMLButtonElement>;

const ResetBtn = ({ label, ...args }: Props) => {
  const themeStore = useTheme();
  const isLightMode = themeStore.theme === 'light';

  return (
    <SC.Container>
      <SC.IconBox {...args}>
        <Icon icon="IcRefresh" size="20px" color={isLightMode ? 'black' : 'white'} />
      </SC.IconBox>
      <SC.SelectedLabelText dangerouslySetInnerHTML={{ __html: label }} />
    </SC.Container>
  );
};

export default ResetBtn;
